import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Chevron, CircleChecked, CircleClose } from 'app/assets/icons'
import { ButtonsDelivery } from './ButtonsDelivery'
import { restaurantServices } from 'shared/utils'
import { SmallText } from 'app/common/typography'
import type { IntlShape } from 'react-intl'
import { FormattedMessage, injectIntl } from 'react-intl'
import { colors } from 'shared/assets/styles'

const { text, grey30, lightWhite } = colors
const {
    DRIVE,
    DELIVEROO,
    UBEREATS,
    ON_SITE,
    TAKEAWAY,
    CLICK_AND_COLLECT
} = restaurantServices
const ICON_SIZE = 20
type Props = {
    deliverooUrl?: string,
    uberEatsUrl?: string,
    services: Array<string>,
    className?: string,
    intl: IntlShape
}
type State = {
    collapsed: boolean
}

class AvailableServicesComponent extends Component<Props, State> {
    state = {
        collapsed: false
    }

    renderService = (service: { name: string, available: boolean }) => {
        const { name, available } = service
        return (
            <Service>
                {available ? (
                    <CircleChecked size={ICON_SIZE} />
                ) : (
                    <CircleClose
                        color="white"
                        size={ICON_SIZE}
                        background={text}
                    />
                )}
                <FormattedMessage id={name}>
                    {(text: string) => (
                        <StyledSmallText>{text}</StyledSmallText>
                    )}
                </FormattedMessage>
            </Service>
        )
    }

    render() {
        const { className, deliverooUrl, uberEatsUrl, services } = this.props
        const borderColor = grey30
        const { collapsed } = this.state
        const hasDelivery =
            services.includes(DELIVEROO) || services.includes(UBEREATS)
        const hasClickAndCollect = services.includes(CLICK_AND_COLLECT)

        const servicesToDisplay = [
            {
                name: 'storelocator.restaurant.takeaway',
                available: services.includes(TAKEAWAY)
            },
            {
                name: 'storelocator.restaurant.onsite',
                available: services.includes(ON_SITE)
            },
            {
                name: 'storelocator.restaurant.drive',
                available: services.includes(DRIVE)
            },
            {
                name: 'clickandcollect',
                available: hasClickAndCollect
            }
        ]

        const deliveryService = {
            name: 'storelocator.restaurant.delivery',
            available: hasDelivery
        }

        return (
            <Fragment>
                <ServicesContainer>
                    {servicesToDisplay.map((service, index) => (
                        <Services key={index}>
                            {this.renderService(service)}
                        </Services>
                    ))}
                </ServicesContainer>
                <Border borderColor={borderColor} />
                <Collapse>
                    <Header
                        onClick={e => {
                            e.stopPropagation()
                            hasDelivery &&
                                this.setState({
                                    collapsed: !this.state.collapsed
                                })
                        }}>
                        {this.renderService(deliveryService)}
                        {hasDelivery && (
                            <Chevron
                                color={text}
                                direction={collapsed ? 'up' : 'down'}
                            />
                        )}
                    </Header>
                    {hasDelivery && collapsed && (
                        <ButtonsDelivery
                            services={services}
                            deliverooUrl={deliverooUrl}
                            uberEatsUrl={uberEatsUrl}
                            className={className}
                        />
                    )}
                </Collapse>
                <Border borderColor={borderColor} />
            </Fragment>
        )
    }
}

const ServicesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    padding: 10px 0;
`

const Border = styled.div`
    border: solid 1px ${props => props.borderColor};
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    width: 100%;
`
const Collapse = styled.div`
    width: 100%;
`
const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 100%;
    padding-bottom: 5px;
`
const Services = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 50%;
`

const Service = styled.div`
    display: flex;
    align-items: center;
    margin-top: 5px;
`
const StyledSmallText = styled(SmallText)`
    margin-left: 10px;
`
const AvailableServices = injectIntl(AvailableServicesComponent)
export { AvailableServices }
